// extracted by mini-css-extract-plugin
export default {"grid-block":"ZvInY","section":"bJ3qo"};